import { GET } from "../../../helpers/restFunction";

export const GetProjectdetails = async (userId: string, jobId?: string) => {
  const path = `/cad/users/${userId}/jobs/${jobId}`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("Error", err);
      return err;
    });
};
